import { render, staticRenderFns } from "./ShipmentDetails.vue?vue&type=template&id=3bd1e137&scoped=true"
import script from "./ShipmentDetails.vue?vue&type=script&lang=js"
export * from "./ShipmentDetails.vue?vue&type=script&lang=js"
import style0 from "./ShipmentDetails.vue?vue&type=style&index=0&id=3bd1e137&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd1e137",
  null
  
)

export default component.exports